import React from 'react';
import { Box, Container, useTheme, useMediaQuery } from '@mui/material';
import Header from './Header';
import Footer from './Footer';
import Sidebar, { DRAWER_WIDTH } from './Sidebar';
import AlertDialog from './AlertDialog';
import SnackbarNotification from './SnackbarNotification';
import Loading from './Loading';
import { NotificationQueue } from './NotificationPopup';
import OrderNotificationHandler from './OrderNotificationHandler';
import { useApp } from '../../context/AppContext';
import useNotifications from '../../hooks/useNotifications';

const Layout = ({ children, maxWidth = 'lg', disableGutters = false }) => {
  const { state } = useApp();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  // Initialize notification system
  const {
    notifications,
    dismissNotification,
    viewNotification,
    isConnected,
    connectionStatus
  } = useNotifications();
  
  const showSidebar = state.isAuthenticated && !isMobile;

  const layoutStyles = {
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: 'background.default'
  };

  const mainContentStyles = {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
   
    transition: theme.transitions.create(['margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  };

  const contentAreaStyles = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    py: 3
  };

  return (
    <Box sx={layoutStyles}>
      {/* Sidebar - only on desktop when authenticated */}
      {showSidebar && <Sidebar />}

      {/* Main Content Area */}
      <Box sx={mainContentStyles}>
        {/* Header */}
        <Header />

        {/* Main Content */}
        <Box component="main" sx={contentAreaStyles}>
          <Container 
            maxWidth={maxWidth} 
            disableGutters={disableGutters}
            sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}
          >
            {children}
          </Container>
        </Box>

        {/* Footer */}
        <Footer />
      </Box>

      {/* Global Components */}
      <AlertDialog />
      <SnackbarNotification />
      
      {/* Notification System */}
      {state.isAuthenticated && (
        <NotificationQueue
          notifications={notifications}
          onDismiss={dismissNotification}
          onView={viewNotification}
        />
      )}
      
      {/* Order Notification Handler */}
      {state.isAuthenticated && <OrderNotificationHandler />}
      
      {/* Global Loading */}
      {state.loading && <Loading open={true} />}
    </Box>
  );
};

export default Layout; 